// extracted by mini-css-extract-plugin
module.exports = {"root":"log-message-root__1IQpi","time":"log-message-time__ic9TG"};